import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import LiveExperience from './LiveExperience';
import VirtualAgent from './VirtualAgent';
import Avatar from './Avatar';
import ErrorBoundary from '../../ErrorBoundary';


class AIAgentTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            // showHomeEnityName: localStorage.getItem("homeEntityName"),
            projectId: null,
            hideBotStore: false,
            // patientAdmissionHeading: ""
        }
    }

    componentDidMount() {
        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#virtual-agent,#avatar,#patient-app")
                .on("click", function () {
                    $("#virtual-agent,#avatar,#patient-app")
                        .removeClass('active');
                    localStorage.setItem("ai-agent-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();

    }

    markActiveTab() {
        $("#virtual-agent,#avatar,#patient-app").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("ai-agent-nav-bar-selection");
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/ai-agent/avatar') || currentPath.includes('/projectmgmt/ai-agent/avatar/')) {
            defaultSelection = "avatar";
        } else if (currentPath.includes('/projectmgmt/ai-agent/patient-app') || currentPath.includes('/projectmgmt/ai-agent/patient-app/')) {
            defaultSelection = "patient-app";
        } else if (currentPath.includes('/projectmgmt/ai-agent') || currentPath.includes('/projectmgmt/ai-agent/')) {
            defaultSelection = "virtual-agent";
        }
        if (defaultSelection !== false) {
            $("#aiAgentNavMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("ai-agent-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#aiAgentNavMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }

    render() {
        this.markActiveTab();
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4" >
                                        <h1 className="m-0 page-title">AI Agent</h1>
                                    </div>
                                    <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                        {/* <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>
                                        {window.SCOPE_VALUE.CURRENT == 10 ? this.state.patientAdmissionHeading : this.state.showHomeEnityName}
                                    </h1> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid" >
                            <div className="border-bottom" style={{ marginLeft: '1vw' }}></div>
                            <div className="tab-class" style={{ marginLeft: '1vw' }}>

                                <ul className="nav nav-tabs border-bottom navCluster" id="aiAgentNavMenu">
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/ai-agent" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="virtual-agent" style={{
                                            marginRight: '15px'
                                            , display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN) ? 'block' : 'none'
                                        }}>
                                            Virtual Agent
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/ai-agent/avatar" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="avatar" style={{
                                            marginRight: '15px',
                                            display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN) ? 'block' : 'none'
                                        }}>
                                            Avatar
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/ai-agent/patient-app" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="patient-app" style={{ marginRight: '15px', display: 'none' }}>
                                            Patient Experience
                                        </li></Link>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/ai-agent/avatar" component={Avatar}></Route>
                        <Route path="/projectmgmt/ai-agent/patient-app" component={LiveExperience}></Route>
                        <Route path="/projectmgmt/ai-agent" component={VirtualAgent}></Route>
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default AIAgentTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/AIAgentTabSettings.js